import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/backspace.tsx
var Backspace = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M11.2483 10L15.2499 14.0017M15.2516 10L11.2499 14.0017M3.53302 10.8645L7.15371 5.61453C7.52703 5.07322 8.14257 4.75 8.80013 4.75H19.2499C20.3545 4.75 21.2499 5.64543 21.2499 6.75V17.25C21.2499 18.3546 20.3545 19.25 19.2499 19.25H8.80013C8.14257 19.25 7.52703 18.9268 7.15371 18.3855L3.53302 13.1355C3.06159 12.4519 3.06158 11.5481 3.53302 10.8645Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.80013 4C7.89599 4 7.04961 4.44443 6.5363 5.18873L2.91561 10.4387C2.26739 11.3787 2.26739 12.6213 2.91561 13.5613L6.5363 18.8113C7.04961 19.5556 7.89599 20 8.80013 20H19.2499C20.7687 20 21.9999 18.7688 21.9999 17.25V6.75C21.9999 5.23122 20.7687 4 19.2499 4H8.80013ZM10.7179 9.46967C11.0108 9.17678 11.4857 9.17678 11.7786 9.46967L13.2499 10.941L14.7213 9.46967C15.0142 9.17678 15.489 9.17678 15.7819 9.46967C16.0748 9.76256 16.0748 10.2374 15.7819 10.5303L14.3106 12.0017L15.7803 13.4713C16.0732 13.7642 16.0732 14.2391 15.7803 14.532C15.4874 14.8249 15.0125 14.8249 14.7196 14.532L13.2499 13.0623L11.7803 14.532C11.4874 14.8249 11.0125 14.8249 10.7196 14.532C10.4267 14.2391 10.4267 13.7642 10.7196 13.4713L12.1893 12.0017L10.7179 10.5303C10.425 10.2374 10.425 9.76256 10.7179 9.46967Z",
		fill: "currentColor"
	})
});
//#endregion
export { Backspace };
